import axios from "axios";
import {
  Button,
  IconButton,
} from "@mui/material";
import styles from "./style.module.css";
import SearchIcon from "@mui/icons-material/Search";
import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import Box from "@mui/material/Box";
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  DataGrid,
  GridColDef,
  GridFilterModel,
  GridToolbar,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import CircularModal from '../../custom/circularModalLoader/circularModalLoader';
import ReportsTable from '../../custom/reportsTable';
import DownloadIcon from '@mui/icons-material/Download';
import { CalendarIcon, LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment, { MomentInput } from "moment";
import { shortKyctransactionDetails } from "../../../utils/constant";
import Title from "../../custom/Title";
import useService from "../../../hooks/useService";
import { getSkycReport } from "../../../services/Reports";

const DataGridContainer = styled.div`
  height: calc(100%);
  overflow-x: auto;
`
export const SkycTransactions = () => {
  let sessionId: any = localStorage.getItem("sessionId")
  const [loading, setLoading] = useState(false);
  const [skycTransactions, setSkycTransactions] = useState<any>([])
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 })
  const [totalCount, setTotalCount] = useState<number>(0)
  const [fromDate, setFromDate] = useState<any>(new Date().toString())
  const [toDate, setToDate] = useState<any>(new Date().toString())
  const { execute } = useService();

  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
    items: [],
    quickFilterExcludeHiddenColumns: true,
    quickFilterValues: [],
  })

  const checkDateDifference = (fromDate: Date, toDate: Date) => {
    const fromDateObj = new Date(fromDate)
    const toDateObj = new Date(toDate)
    const differenceInTime = toDateObj.getTime() - fromDateObj.getTime()
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);


    if (differenceInDays > 30) return true
    else return false
  }

  const getSkycTransactionData = async () => {
    try {
      let dateRange = checkDateDifference(fromDate, toDate)
      if(dateRange) return alert('Date range should be less than 30 days!')

      setLoading(true)
      const params = {
        // sessionId: sessionId,
        fromDate,
        toDate,
        // page: paginationModel.page,
        // pageSize: paginationModel.pageSize
      }

    //   const response = await axios.post(
    //     "/api/pvcReports/shortKycTransactionReport",    getSkycReport
    //     params
    //   )
      const { data } = await execute(() => getSkycReport({params}))


      setLoading(false)
      setSkycTransactions(data?.data || [])
      console.log(data?.data,'skyc_data')
    } catch (error) {
      setLoading(false)
      console.error(error)
      alert('Unable to get skyc transactions!')
    }
  }

  const getSkycTransactionDataColumns = () => {
    let minWidth = 100

    return shortKyctransactionDetails.map((inboundField: any) => {

      const row: GridColDef = {
        field: inboundField.id,
        headerName: inboundField.label,
        minWidth,
        align: 'left'
      }

      switch (inboundField.id) {
        case "srno":
          row.minWidth = 80;
          row.renderCell = params => {
            return params.row.srno
          }
          break;
        case "customerName":
          row.minWidth = 150;
          row.renderCell = params => {
            return params.row.customerName
          }
          break;
        case "customerPanNumber":
          row.minWidth = 150;
          row.renderCell = params => {
            return params.row.customerPanNumber
          }
          break;
        case "customerCategory":
          row.minWidth = 200;
          row.renderCell = params => {
            return params.row.customerCategory
          }
          break;
        case "createdOn":
          row.minWidth = 150;
          row.renderCell = params => {
            return params.row.createdOn 
          }
          break;
        case "transactionCount":
          row.minWidth = 150;
          row.renderCell = params => { 
            return params.row.transactionCount 
          }
          break;
        case "remarks":
          row.minWidth = 150;
          row.renderCell = params => {
            return params.row.remarks
          }
          break;
        case "totalGoldFineWeight":
          row.minWidth = 150;
          row.renderCell = params => {
            return params.row.totalGoldFineWeight 
          }
          break;
        case "totalSilverFineWeight":
          row.minWidth = 150;
          row.renderCell = params => {
            return params.row.totalSilverFineWeight
          }
          break;
        default:
          row.minWidth = 100
          break;
      }
      return row;
    })
  }

  const filterModal = () => {
    return (
      <Box className={styles.filterModal}>
        <Box className={styles.filterModalRow}>
          <Box className={styles.boxModal}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <MobileDatePicker
                slotProps={{
                  textField: { fullWidth: true, size: 'small' },
                    field: {
                      InputProps: {
                      endAdornment: <IconButton><CalendarIcon /></IconButton>
                    }
                  }
                }}
                label='Start Date'
                onChange={(value) => setFromDate(value?.toString()!)}
                value={moment(fromDate || new Date().toString() as MomentInput)}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <MobileDatePicker
                slotProps={{
                  textField: { fullWidth: true, size: 'small' },
                    field: {
                      InputProps: {
                      endAdornment: <IconButton><CalendarIcon /></IconButton>
                    }
                  }
                }}
                label='End Date'
                onChange={(value) => setToDate(value?.toString()!)}
                value={moment(toDate || new Date().toString() as MomentInput)}
              />
            </LocalizationProvider>
          </Box>
          <Box >
            <Button
              variant="contained"
              onClick={getSkycTransactionData}
              endIcon={<SearchIcon />}
              disabled={!fromDate || !toDate}
            >
              Apply Filter
            </Button>
          </Box>
          {/* <Box >
            <Button
              variant="contained"
              onClick={() => setShowIssueModal('true')}
              endIcon={<DownloadIcon />}
              disabled={skycTransactions.length <= 0}
            >
              Export All
            </Button>
          </Box> */}
        </Box>
      </Box>
    )
  }

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarExport csvOptions={{ fileName: 'SKYC Transaction Report' }} />
      </GridToolbarContainer>
    )
  }

  const renderTable = () => {
    return (
      <>
        <div>
          {loading && <CircularModal thickness={4} />}
          <Box sx={{ width: "100%", height: '500px', overflow: 'auto' }}>
            <DataGridContainer>
              <ReportsTable
                className="payrollGrid"
                rows={skycTransactions || []}
                columns={getSkycTransactionDataColumns()}
                getRowId={(row) => row.srno}
                disableRowSelectionOnClick={true}
                rowHeight={50}
                slots={{ toolbar: CustomToolbar }}
                hideFooter={true}
                fixedHeight={true}
              />
            </DataGridContainer>
          </Box>
        </div>
      </>
    );
  }

  // useEffect(() => {
  //   getSkycTransactionData()
  // }, [paginationModel.page])

  return (
    <Box className={styles.container}>
    <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Short KYC Transaction Report</Title>
      {filterModal()}
      {renderTable()}
    </Box>
  )
}
